import { MiddlewareNextFn, RelayRequestAny } from "react-relay-network-modern";
import { toast } from "react-toastify";
import { ERROR_MESSAGES } from "../ERROR_MESSAGES";
import { EXTEND_ERROR_MESSAGE_EFN_OAK } from "../EXTEND_ERROR_MESSAGE_EFN_OAK";
import { ReduxStore } from "../redux/redux-store";
import { logout } from "../redux/slices/auth.slice";
import { dynamicEfnOakMessage } from "../utils/dynamicEfnOakMessage";

const LOGOUT_ERRORS = [
	"auth-token-unknown",
	"auth-token-not-set-in-headers",
	"infectopharmauth_token_not_set_in_headers_exception",
	"auth_token_not_set_in_headers_exception",
	"auth_authorisation_exception",
	"auth_token_unknown_exception",
	"auth_account_not_permitted_exception",
	"auth_bearer_token_unknown_exception",
	"auth_authenticate_unspecified_auth",
	"auth_refresh_token_expired",
	"auth_jwt_malformed",
	"auth_account_not_recognized",
	"auth_account_not_found",
	"auth_user_not_found",
	"auth_unknown_permission_kind",
].map((e) => e.toLowerCase());

export const ErrorHandlingMiddleware = (next: MiddlewareNextFn) => async (req: RelayRequestAny) => {
	const res = await next(req);
	const errors = res.errors?.map((e) => e.message?.toLowerCase()) || [];
	const needsToLogout = LOGOUT_ERRORS.find((le) => errors.includes(le));

	if (needsToLogout) {
		ReduxStore.dispatch(logout());
	} else {
		errors?.forEach((e) => {
			let message: string;

			if (EXTEND_ERROR_MESSAGE_EFN_OAK[e]) {
				const dynamicValue = dynamicEfnOakMessage();
				message = EXTEND_ERROR_MESSAGE_EFN_OAK[e](dynamicValue);
			} else {
				message = ERROR_MESSAGES[e] || e;
			}

			toast.error(message);
		});
	}

	return res;
};
